/* eslint-disable radix */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-param-reassign */
import React, { useEffect, useState } from "react";

import { TextField } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import Tooltip from "@material-ui/core/Tooltip";
import PropTypes from "prop-types";
import moment from "moment";
import { concat, first} from "lodash"

import { prettyDate, serverDate } from "../../../utils/date";
import DateSelector from "../../Shared/DateSelector";
import DefaultDataTable from "../../Shared/DefaultDataTable";
import Selector from "../../Shared/Selector";
import TabNavigationCtrlFilterPanel from "../../TabNavigationCtrlFilterPanel";

import useStyles from "./styles";
import { getDataStorage, removeDataStorage, setDataStorage } from "../../../utils/filterManagementDataStore";
import ModalSave from "./modal-save";

import { isDatePreviousThanToday } from "../../../utils/date";
import ModalQuotasDatesIssues from "./modal-quotas-dates-issues";
import ModalRemovePlant  from "../PlantsTabComponent/modal-remove-plant";


const getDataStorageBranch = () => getDataStorage('plant_quotas_config_checkSingleBranch');
const getDataStorageTurn = () => getDataStorage('plant_quotas_config_selectedTurn');
const getDataStorageTurnDate = () => getDataStorage('plant_quotas_config_selectedTurnDate');

const PlantQuotasTabComponent = ({
initialQuotas,
  quotas,
  branches,
  turns,
  filter,
  setFilter,
  subRoutes,
  addQuantity,
  subtractQuantity,
  setQuantity,
  saveConfig,
  quotasDatesIssues,
  schedulingsDatesIssues,
  clearQuotasDatesIssues,
  clearSchedulingDatesIssues,
  openConfirmDialog,
  getNotificationsFromSchedConfigAsync
}) => {
  const classes = useStyles();

  const [availableQuotas, setAvailableQuotas] = useState(0);
  const [autofocus, setAutofocus] = useState(null);
  const [isOpenSaveEndDateForm, setOpenSaveEndDateForm] = useState(false);

  const handleSaveData = (startDate, endDate) => {

   let quotasInfo = [];

   quotas.forEach(timeBlock => {
      timeBlock.plants.forEach(plant => {
         quotasInfo.push(plant.quota);
      });
   });

   const timeRange = {
      start_date: serverDate(startDate),
      end_date: serverDate(endDate)
   };

   const quotasConfig = {
      quotas: quotasInfo,
      timeRange
   };

   saveConfig(quotasConfig).then((response)=>{
    const { success , hasWarning} = response;
    openConfirmDialog({
      isOpen: success && !hasWarning,
      title: "Configurações salvas com sucesso!",
    });
   })

  };

  const getQuotaMaxEndDate = () => {
      let timeBlockForever = quotas.find(timeBlock => timeBlock.end_date ===  null);
      if (timeBlockForever !== undefined) {
         return null;
      }

      return new Date(
         Math.max(
           ...quotas.map(timeBlock => {
             return moment(timeBlock.end_date);
           }),
         ),
      );
  }

  const handleCloseSaveEndDateModal = () =>{
    setOpenSaveEndDateForm(false);
  }

  const calculateAvailableQuotas = () => {
    let diff = 0;
    const sum =
      quotas &&
      quotas.reduce((total, currentValue) => total + currentValue.quantity, 0);
    if (quotas[0] && quotas[0].capacity) {
      diff = quotas[0].capacity - sum;
    }

    setAvailableQuotas(diff);
  };

  useEffect(calculateAvailableQuotas, [
    quotas,
    filter.plantQuotasTurn,
    setAvailableQuotas,
  ]);

  const getTurnDate = () => {
    return (filter.plantQuotasDate || getDataStorageTurnDate());
  }

  const isCurrentEqualsInitialQuotas= () => {
    return JSON.stringify(quotas) === JSON.stringify(initialQuotas);
  }

  const isDisabledTabActions = () => {
     return isDatePreviousThanToday(getTurnDate());
  }

  const isDisabledTextFieldAndActions = () => {
   return isDisabledTabActions();
  }

  const isDisabledSaveButton = () => {
      if (isDisabledTabActions()){
         return true;
      }
      return isCurrentEqualsInitialQuotas();
   }

  const noDataMessage = () => {
    if (!filter.plantQuotasBranch && !getDataStorageBranch()) {
      return "Por favor, selecione uma filial.";
    }
    if (!filter.plantQuotasDate && !getDataStorageTurnDate()) {
      return "Por favor, selecione uma data.";
    }
    if (!filter.plantQuotasTurn && !getDataStorageTurn()) {
      return "Não há turnos configurados na data selecionada.";
    }
    return "Não existem dados a serem apresentados.";
  };

  const counterPlantPerRow = (quotas, indexTurn) => {
    return quotas[indexTurn]?.plants?.map((item) => Number(item?.quota?.quantity))
    .reduce((total, present) => {
      return total + present
    }, 0);
  }

  const AddButton = (item) => {
      const { row, indexTurn, indexPlant } = item

      const sumQuantityPlantRow = counterPlantPerRow(quotas, indexTurn)
      const currentQuotaQuantity = quotas[indexTurn]?.plants[indexPlant]?.quota?.quantity;
      const isTurnCapacityLimitReached = sumQuantityPlantRow >= row.capacity;

      const dockLimit = quotas[indexTurn]?.plants[indexPlant]?.dock_max_capacity;
      const isDockLimitReached = currentQuotaQuantity >= dockLimit;
      const disabledAction = isDockLimitReached || isTurnCapacityLimitReached;

      let validationMessage = "";
      if (isDockLimitReached){
         validationMessage = "Limite de docas alcançado.";
      }else if(isTurnCapacityLimitReached){
         validationMessage = "Não existem mais cotas para distribuir.";
      }

      return (
      <Tooltip
         arrow
         placement="bottom-start"
         title={validationMessage}
         disableHoverListener={!disabledAction}
      >
         <span>
         <IconButton
            disabled={isDisabledTextFieldAndActions()}
            data-cy="add-button"
            id="add-button"
            onClick={() => {
             if( !disabledAction ){
               addQuantity(item);
             }
            }}
         >

            <AddIcon fontSize="small" color="primary" />
         </IconButton>
         </span>
      </Tooltip>
    );
  };

  const SubtractButton = (item) => {
    const { currentCapacityByPlant } = item

    const isNegativeOrZero = currentCapacityByPlant  <= 0

    return (

      <Tooltip
        arrow
        placement="bottom-start"
        title="Não podem ser declarados valores negativos"
        disableHoverListener={!isNegativeOrZero || isDisabledTextFieldAndActions()}
      >
         <span>
        <IconButton
          disabled={isDisabledTextFieldAndActions()}
          data-cy="subtract-quantity"
          id="subtract-quantity"
          onClick={() => {

            if(item.quantity > 0) {
               if(!isNegativeOrZero){
                  subtractQuantity(item);
               }
            }
          }}
        >
          <RemoveIcon fontSize="small" color="primary" />
        </IconButton>
        </span>
      </Tooltip>
    );
  };

  const quotesGroupBy = (quotasData, propriety) => {
    return quotasData.reduce((acc, obj) => {
      let key = obj[propriety];
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj);
      return acc;
    }, {});
  }

  const extractOnlyPlantsOfQuotas = ( dataQuotas ) => {
    let plantDataQuotas = [];
    dataQuotas.forEach(({plants}) => {
      plants.forEach(({quota}) => {
        plantDataQuotas.push(quota);
      })
    })

    return plantDataQuotas;
  }

  const countDistributedQuotasByPlant = (quotas) => {
    const plants = extractOnlyPlantsOfQuotas( quotas );
    const quotesGroupedByIdPlant = quotesGroupBy(plants, 'id_plant');
    Object.values(quotesGroupedByIdPlant).map((quotas) => {
      return quotas.quantity = quotas.reduce((total, quota) => {
        return total + quota.quantity;
        }, 0)
    });

    return quotesGroupedByIdPlant;
  }

  const getDistributedQuotasByPlantId = (quotas, plantId) => {
    return countDistributedQuotasByPlant(quotas)[plantId].quantity
  }

  const loadQuotas = () => {
    const plantDate = filter.plantQuotasDate || getDataStorage('plant_quotas_config_selectedTurnDate');
    const branchId = filter.plantQuotasBranch || getDataStorage('plant_quotas_config_checkSingleBranch')?.value;

    if (branchId && plantDate) { //Revisar esta condição
      return quotas;
    }
    return [];
  };

  const handleBranchFilterChange = (selectedBranch) => {
    removeDataStorage('plant_quotas_config_selectedTurn');
    removeDataStorage('plant_quotas_config_selectedTurnDate');
    filter.plantQuotasTurn = null;
    filter.plantQuotasDate = null;
    setFilter({ ...filter, plantQuotasBranch: selectedBranch && selectedBranch.value });
  };

  const handlePlantQuotasDateFilterChange = (selectedPlantQuotasDate) => {
    removeDataStorage('plant_quotas_config_selectedTurn');
    filter.plantQuotasTurn = null;
    setFilter({ ...filter, plantQuotasDate: selectedPlantQuotasDate });
  };

  const handleOnChange = (funcChange, valueStorage, nameStorage) => {
    funcChange(valueStorage)
    if (valueStorage !== null) {
      setDataStorage(nameStorage, valueStorage);
    } else {
      removeDataStorage(nameStorage);
    }
  }

  const columnPlants = quotas?.map((quota) => {
    return quota?.plants?.map((plant, indexPlant) => {
      return {
        name: plant.name + `\nTotal: ${getDistributedQuotasByPlantId(quotas, plant.id)}`,
        maxWidth: "175px",
        selector: "capacity",
        sortable: true,
        cell: (row) => {
          // tratar a row mediante a um indice
          const indexTurn = quotas?.findIndex(quota => quota?.id === row?.id);
          const currentCapacityByTurn = quotas[indexTurn]?.capacity
          const currentCapacityByPlant = quotas[indexTurn]?.plants
            ?.map(item => Number(item?.quota?.quantity))
            ?.reduce((acc, value) => acc + value, 0)

          let quantity = quotas[indexTurn]?.plants[indexPlant]?.quota?.quantity

          const focusKey = `${indexPlant}-${indexTurn}`;

          return (
            <>
              <SubtractButton {...{ row, indexTurn, indexPlant, currentCapacityByPlant, quantity }} />
              <TextField
                variant="outlined"
                className={classes.quantity}
                autoFocus={focusKey === autofocus}
                data-cy="quantity-field"
                id="quantity-field"
                value={quantity}
                disabled= {isDisabledTextFieldAndActions()}
                onChange={(e) => {
                  setAutofocus(focusKey);
                  if ( !isNaN(e.target.value) ) {
                     const currentUsage =  (currentCapacityByPlant - Number(quantity) + Number(e.target.value));
                     let newQuantity = Number(e.target.value);

                     const dockLimit = quotas[indexTurn]?.plants[indexPlant]?.dock_max_capacity;
                     const isDockLimitReached = newQuantity > dockLimit;

                     if(!isDockLimitReached){
                        if(currentUsage > currentCapacityByTurn){
                           const maxQuantityAvailable = currentCapacityByTurn - currentCapacityByPlant + Number(quantity);
                           newQuantity = maxQuantityAvailable;
                        }
                        setQuantity({
                           newQuantity: newQuantity,
                           indexPlant,
                           indexTurn
                        });
                     }
                  } else {
                    if (!quantity) {
                      setQuantity({newQuantity: 0, indexPlant, indexTurn});
                    }
                  }
                }}
              />
              <AddButton {...{row, indexPlant, indexTurn }} />
            </>
          );
        },
      }
    })
  })

  const columns = [
    {
      name: "Turno",
      selector: "description",
      maxWidth: "200px",
      sortable: true
    },
    {
      name: "Horário",
      maxWidth: "200px",
      selector: "starts_at",
      format: (row) => <div>{moment(row.starts_at, "HH:mm:ss").format("HH:mm")} ~ {moment(row.ends_at, "HH:mm:ss").format("HH:mm")}</div>,
      sortable: true,
    },
    {
      name: "Período do Turno",
      maxWidth: "200px",
      cell: (row) => <div>
        {prettyDate(row.start_date)} {
          row.end_date ? " a " + prettyDate(row.end_date) : " em diante"
        }</div>,
      sortable: true,
    },
    {
      name: "Nº de Cotas",
      maxWidth: "175px",
      selector: "capacity",
      sortable: true,
      cell: (row) => {
        const indexTurn = quotas.findIndex(quota => quota.id === row.id)
        const sumQuantityPlantRow = counterPlantPerRow(quotas, indexTurn)

        return <div>{sumQuantityPlantRow}/{row.capacity}</div>
      }
      // eslint-disable-next-line react/display-name
    },
    {
      name: "Validade da Distribuição",
      maxWidth: "175px",
      selector: "validate",
      sortable: true,
      cell: (row) => {
        const indexTurn = quotas.findIndex(quota => quota.id === row.id)
        if (indexTurn === -1){
          return <div>-</div>;
        }else{
                    
          if (!quotas?.plants?.length){
            const plant = quotas[indexTurn]?.plants?.find( e => !!e?.quota?.starts_date);

            if (!!plant?.quota){
              const { quota } = plant;
              return (<div>
                {prettyDate(quota?.starts_date)} 
                {
                  quota?.ends_date ? " a " + prettyDate(quota?.ends_date) : " em diante"
                }
              </div>);
            }
            
          }
          return <div>-</div>;
        }
      }
      // eslint-disable-next-line react/display-name
    },
  ];

  const handleColumns = () => {
    if(first(columnPlants)?.length > 0 ) {
      return concat(columns, first(columnPlants))
    }

    return columns
  }

  const getDateSelected = () => filter.plantQuotasDate ?? getDataStorageTurnDate();

  return (
    <>
      <TabNavigationCtrlFilterPanel
        data-cy="plant-quota-filter"
        id="plant-quota-filter"
        headerFilter={
          <Grid className={classes.filters}>
            <Grid className={classes.branchFilter}>
              <Selector
                options={branches}
                placeholder="Filtrar por filial"
                search
                isClearable
                data-cy="plant-quota-filter-branch"
                id="plant-quota-filter-branch"
                selected={filter.plantQuotasBranch ?? getDataStorageBranch()?.value}
                value={getDataStorageBranch()}
                onChange={(selectedBranch) =>
                  handleOnChange(
                    handleBranchFilterChange,
                    selectedBranch,
                    'plant_quotas_config_checkSingleBranch'
                  )
                }
              />
            </Grid>
            <Grid className={classes.dateFilter}>
              <DateSelector
                selected={getDateSelected()}
                placeholder="Filtrar por Data"
                data-cy="plant-quota-date-filter"
                disabled={!filter.branch && !getDataStorageBranch()}
                onChange={(selectedPlantQuotasDate) =>
                  handleOnChange(
                    handlePlantQuotasDateFilterChange,
                    selectedPlantQuotasDate,
                    'plant_quotas_config_selectedTurnDate'
                  )
                }
              />
            </Grid>
          </Grid>
        }
        controlAreaClassName={classes.controlAreaClass}
        controlArea={
          <Box
            component="div"
            display="flex"
            style={{ width: "100%", padding: 0, margin: 0 }}
            justifyContent="flex-end"
            alignItems="center"
            m={1}
          >
            <Box component="div" m={1} style={{ padding: 0, margin: 0 }}>
              {(filter.plantQuotasTurn || getDataStorageTurn()) && availableQuotas >= 0 && (
                <Button
                  disabled={true}
                  data-cy="plant-quota-available"
                  id="plant-quota-available"
                  className={classes.quotasInformation}
                  variant="outlined"
                >
                  {`Há ${availableQuotas} cotas disponíveís`}
                </Button>
              )}
              {(filter.plantQuotasTurn || getDataStorageTurn()) && availableQuotas < 0 && (
                <Button
                  disabled={true}
                  className={classes.quotasInformationNegative}
                  data-cy="plant-quota-not-available"
                  id="plant-quota-not-available"
                  variant="outlined"
                >
                  {`Você ultrapassou ${availableQuotas * -1} cota(s)`}
                </Button>
              )}
            </Box>
            <Box component="div" m={1} style={{ padding: 0, margin: 0 }}>
              <Button
                color="secondary"
                variant="contained"
                data-cy="plant-quota-save"
                id="plant-quota-save"
                size="large"
                disabled={isDisabledSaveButton()}
                style={{ minWidth: "200px", height: "67px" }}
                className={classes.addButton}
                onClick={() => setOpenSaveEndDateForm(true)}
              >
                Salvar
              </Button>
              <ModalSave
                open={isOpenSaveEndDateForm}
                handleClose={handleCloseSaveEndDateModal}
                handleSave={handleSaveData}
                data-cy="plant-quota-modal-save"
                id="plant-quota-modal-save"
                startDate={prettyDate(getDateSelected())}
                endDate={getQuotaMaxEndDate()}
              />
              <ModalQuotasDatesIssues 
                isOpen ={!!quotasDatesIssues?.data && quotasDatesIssues?.data.length > 0}
                data={quotasDatesIssues}
                data-cy="plant-quota-issues"
                id="plant-quota-issues"
                closeReadingNotificationDialog={ () => {
                  clearQuotasDatesIssues();
                  openConfirmDialog({
                    isOpen: true,
                    title: "Configurações salvas com sucesso!",
                  });
                }}
              />
              <ModalRemovePlant
                 isOpen ={!!schedulingsDatesIssues?.data && schedulingsDatesIssues?.data.length > 0}
                 data={schedulingsDatesIssues}
                 data-cy="plant-quota-remove-modal"
                 id="plant-quota-remove-modal"
                 closeReadingNotificationDialog={ () => {
                   clearSchedulingDatesIssues();
                   getNotificationsFromSchedConfigAsync();
                   openConfirmDialog({
                     isOpen: true,
                     title: "Erro ao salvar as configurações!",
                   });
                 }}
              />
            </Box>
          </Box>
        }
        subRoutes={subRoutes}
      >
        <DefaultDataTable
          className={`DefaultDataTable ${classes.rdt_TableCol_Sortable}`}
          columns={handleColumns()}
          data-cy="plant-quota-table"
          id="plant-quota-table"
          data={loadQuotas()}
          noDataMessage={noDataMessage()}
        />
      </TabNavigationCtrlFilterPanel>
    </>
  );
};
PlantQuotasTabComponent.propTypes = {
  quotas: PropTypes.array.isRequired,
  branches: PropTypes.array.isRequired,
  turns: PropTypes.array.isRequired,
  filter: PropTypes.object.isRequired,
  setFilter: PropTypes.func.isRequired,
  subRoutes: PropTypes.array.isRequired,
  addQuantity: PropTypes.func.isRequired,
  subtractQuantity: PropTypes.func.isRequired,
  saveConfig: PropTypes.func.isRequired,
  getNotificationsFromSchedConfigAsync: PropTypes.func.isRequired
};
export default PlantQuotasTabComponent;
